const messages = {
  en: {
    general: {
      search: 'Search',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      remove: 'Remove',
      save: 'Save',
      update: 'Update',
      cancel: 'Cancel',
      cancel2: 'Cancel',
      continue: 'Continue',
      activate: 'activate',
      deactivate: 'deactivate',
      active: 'active',
      inactive: 'inactive',
      specialPrice: 'Special Price',
      removePhoto: 'Too many images uploaded',
      yes: 'Yes',
      no: 'No',
      success: 'Success',
      required: 'required',
      back: 'back',
      next: 'Next',
      finish: 'Finish',
      duplicate: 'Duplicate',
      select: 'Select',
      all: 'All',
      alls: 'All',
      reset: 'Reset',
      export: 'Export',
      loadMore: 'Load More',
      viewDetails: 'View Details',
      showing: 'Showing {length} result(s)',
      enable: 'activate',
      disable: 'deactivate',
      product: 'product',
      logout: 'Logout',
      from: 'from',
      to: 'to',
      cancelCourier: 'Cancel courier',
      agree: 'Agree',
      agreePopupMessage: 'To allow the browser to play audio you need to click "Agree". This will play a test sound in order to activate sound play.',
      day: 'day',
      notCompleted: 'not completed',
      saveChanges: 'Save Changes',
      doYouWantToLogout: 'Do you want to logout?',
      minutes: 'minutes',
      hour: 'hour',
      hours: 'hours',
      customSort: 'Company use custom sort',
      deliveryMethod: 'Delivery Methods',
      none: 'None',
      included: 'Included',
      error_not_open_kiosk: 'Is closed!',
      error_not_open_table: 'You must be at the table to order. Go back to the table and scan again!',
      error_not_open_table_1: 'Your link is not valid. Please go to the table and scan the QR code again',
      error_not_open_table_2: '"Order to the table" service is not available. Please ask the staff',
      error_not_open_table_3: '"Order to the table" service is not available. Please ask the staff',
      error_not_open_table_4: '"Order to the table" service is not available. Please ask the staff',
      error_not_open_table_5: '"Order to the table" service is not available. Please ask the staff',
      error_not_open_table_6: '"Order to the table" service is not available. Please ask the staff',
      error_not_open_table_7: 'Your link is not valid. Please go to the table and scan the QR code again',
      error_not_open_table_8: 'The location is out of working hours. Please wait until opening time and scan the QR code at the table',
      error: 'Error'
    },
    addOrder: {
      'back': 'Back',
      'close': 'Close',
      'productNavbar': 'Product',
      'menuNavbar': 'Menu',
      'payNavbar': 'Pay',
      'optionNavar': 'Options',
      'chooseLanguage': 'Choose Your Language',
      'splashScreenOrderNow': 'Order now',
      'addToCart': 'The product has been added to cart',
      'order_id_freeze': 'The payment has been initiated. Please proceed with the payment or wait for the payment link to expire to modify the order!',
      'euPlatesc_error': 'A apărut o problemă la solicitarea ta!',
      'euPlatesc_error1': 'Autentificare esuata',
      'euPlatesc_error2': 'Fonduri insuficiente',
      'euPlatesc_error3': 'Tranzactie esuata',
      'euPlatesc_error4': 'Card expirat',
      'euPlatesc_error5': 'Raspuns invalid',
      'relogin': 'Is there anyone else at the table? If it is not, delete the previous order!',
      'deleteOrder': 'Delete',
      'couninueOrder': 'Contiune',
      'errorRelogin': 'There is an open order! Please address the waiter to close the order!',
      'finishOrderMsg': 'Comanda ta a fost plasată cu succes! Rămâi la masă, mai departe ne ocupăm noi de tot!',
      'errorFinishOrderMsg': 'Plata eșuată! Va rugăm verificați datele introduse pentru plata! Incearcă din nou sau adresează-te ospătarului!',
      'payByCard': 'Pay with card',
      'payByCashMachine': 'Insert the bills into the machine',
      'payByCashMachineDone': 'Please wait!',
      'howPay': 'How do you want to pay?',
      'posGeneralError': 'Transaction failed!',
      'selectMinMax': 'You can select',
      'selectMin': ' minumum',
      'selectMax': ' maximum',
      'cartBtn': 'My Cart',
      'emptyCartBtn': 'Empty Cart',
      'splashScreenWrapperStart': 'Tap the screen to start an order',
      'swipeUpTooltip': 'Swipe to the next category',
      'resetQuestion': 'Do you want to start from the beginning?',
      'emptyCart': 'Do you want to delete all products from cart?',
      'emptyCartProduct': 'Do you want to delete product from cart?',
      'yes': 'Yes',
      'no': 'No',
      'soldWithAdd': 'Add',
      'soldWithNo': 'No, thank you',
      'soldWithExtra': 'Total extra',
      'soldWithTitle': 'Recommendation',
      'couponExit': 'Tap anywhere to exit',
      'couponTitle': 'Enter coupon code',
      'enterCui': 'Enter the CUI',
      'noProductsFound': 'Searched products were not found.',
      'couponPlaceholder': 'Type coupon code',
      'pagerTitle': 'Scan the QR code or write the code on the pager',
      'pagerPlaceholder': 'Pager code',
      'pagerBtn': 'Add Pager',
      'couponBtn': 'Apply coupon:',
      'commentBtn': 'Additional Information:',
      'couponButton': 'Apply',
      'couponBtn2': 'Got a promotional code?',
      'step1': 'Wait for your order nuber to appear on the screen',
      'step2': 'Pick up your order at the cash desk',
      'yourOrderNr': 'Order number',
      'doneShortly': 'Your order is being prepared.',
      'thenks': 'Thank you!',
      'qrStep1': 'Step 1: Scan the QR code with your smartphone camera.',
      'qrStep2': 'Step 2: Go to the link, fill in the fields (card number, email) and check the boxes. Warning! Terms and conditions acceptance is mandatory, otherwise payment cannot be made.',
      'qrStep3': 'Step 3: Click on the Pay online button',
      'qrStep4': 'Step 4: In a few seconds you will receive the payment confirmation.',
      'qrCancel': 'Cancel',
      'qrText': 'You have ',
      'qrText2': 'seconds to pay the order or the order will be cancelled',
      'backShopping': 'Back to menu',
      'qr': 'Online by scanning the QR code',
      'cash_waiter': 'Cash to the waiter',
      'cash_bar': 'Cash at the bar',
      'pos_waiter': 'POS to the waiter',
      'pos_bar': 'CARD/POS at the bar',
      'card': 'Online payment',
      'counter': 'At the cashier',
      'counter_cash': 'At the cashier cash',
      'counter_pos': 'At the cashier POS',
      'pack': 'Where will you be eating today?',
      'takeAway': 'Take Away',
      'takeAway_first': 'Take',
      'takeAway_second': 'Away',
      'dineIn': 'Eat In',
      'dineIn_first': 'Eat',
      'dineIn_second': 'In',
      'paymentOptions': 'Payment Options',
      'empty': 'Your cart is empty',
      'backToMenu': 'Back to menu',
      'total': 'Total:',
      'search': 'Search',
      'titleClient': 'Customer',
      'titleMethod': 'Delivery method',
      'titleLocation': 'Location',
      'titleAdress': 'Delivery address',
      'titleStatus': 'Status',
      'done': 'Done',
      'datepicker': 'Pick a date',
      'hourpicker': 'Pick a hour',
      'how_many': 'For how many people the reservation is made',
      'tags': 'Order from',
      'titlePopupTip': 'Add Value',
      'btnPopup': 'Add',
      'titlePopupCoupon': 'Add coupon',
      'errorPopupCoupon': 'Wrong coupon',
      'errorProduct1': 'The products are no longer available and have been deleted from the cart',
      'errorProduct2': 'One or more products are no longer available and have been deleted from the cart',
      'errorProduct3': 'You must have products in your cart to be able to order!',
      'errorProduct4': 'Please select the method and location',
      'errorProduct5': 'Please add a customer',
      'errorProduct6': 'Payment method not selected',
      'errorProduct7': 'Please add an adress',
      'add': 'Add',
      'addFor': 'Adaugă for ',
      'edit': 'Edit',
      'next_to_option': 'Add',
      'prev_to_option': 'Prev',
      'infosup': 'Add additional information',
      'state': 'County',
      'city': 'Town',
      'adress': 'Block, staircase, floor, apartment',
      'number': 'Number',
      'street': 'Street',
      'adressname': 'Address Name',
      'sexf': 'Female',
      'sexm': 'Male',
      'sex': 'Sex',
      'birthdate': 'Date of birth',
      'contactperson': 'Contact person',
      'newclient': 'Add or choose client',
      'newadress': 'Add or choose the address',
      'save1': 'Choose and save changes',
      'deliveryAdress': 'Add address',
      'deliveryAdressEdit': 'Edit adresa',
      'firstName': 'First name',
      'lastName': 'Last name',
      'contactPers': 'Contact person',
      'clientSelected': 'Selected customer',
      'clearFields': 'Clear the fields',
      'addAdress': '+ Add the address',
      'existingClient': 'Order from',
      'orderNow': 'Pay',
      'pos': 'With card',
      'cash': 'Cash',
      'free': 'Free',
      'coment': 'Comment Order',
      'addTip': 'Add tip:',
      'addTipValue': 'Enter the amount',
      'addTipButton': 'Add',
      'removeTip': 'Remove tip',
      'removeTipButton': 'Remove',
      'addCoupon': 'Add discount coupon',
      'removeCoupon': 'Delete coupon',
      'removeCouponButton': 'Delete',
      'modif': 'Edit',
      'delete': 'Delete',
      'freeProd': 'Free Product',
      'info': 'Info',
      'orderDet': 'Order Details',
      'cartDet': 'My Cart',
      'fast': 'As soon as possible',
      'selectHour': 'Select the time',
      'selectPayment': 'Select the payment method',
      'pleaseSelectMethodAndLoc': 'Please select the method and location!',
      'locSelect': 'Select a location',
      'searchProduct': 'search products',
      'phone': 'Phone',
      'email': 'E-mail',
      'inlocation': 'In Location',
      'cuiPlaceholder': 'CUI on receipt?',
      'emailFieldsTitle1': 'Ajută-ne să îmbunătățim experiența',
      'emailFieldsTitle2': 'Lasă-ne un email pentru a-ți trimite confirmarea comenzii!',
      'emailPlaceholder': 'Adresa e-mail',
      'phonePlaceholder': 'Phone Number',
      'phoneFieldsTitle1': 'Enter the phone number:',
      'phoneSearch': 'Add',
      'client': 'Client:',
      'newClient': 'New client:',
      'phoneFidelityTitle': 'Load loyalty points?',
      'phoneFieldsTitle2': 'Or scan the QR code from the application',
      'phoneError': 'Phone invalid',
      'qrError': 'Invalid Qr code, scan again or enter the phone number!',
      'emailError': 'Email invalid',
      'adressNotInRange': 'Not in range, please change the adress!',
      'adressNotCorect': 'Adress is not correct',
      'continueToPay': 'Proceed to Payment',
      'loyalityNoSms': 'Want loyalty points?',
      'noLoyalitySms': 'Do you want to know when the order is ready?',
      'loyalitySms': 'Want to know when your order is ready and get loyalty points?',
      'new_client_fidelity': 'After creating an in-app account with this phone number, loyalty points will be automatically allocated to that account.',
      'cardDesc1': 'Card payment processing',
      'cardDesc2': 'Please wait a few moments while your transaction is processed',
      'cardDesc3': 'Thank you for your patience!'
    }
  },
  ro: {
    general: {
      search: 'Caută',
      add: 'Adaugă',
      edit: 'Editează',
      delete: 'Șterge',
      remove: 'Elimină',
      save: 'Salvează',
      update: 'Actualizează',
      cancel: 'Anulează',
      cancel2: 'Renunță',
      continue: 'Continuă',
      activate: 'activează',
      deactivate: 'dezactivează',
      active: 'activ',
      inactive: 'inactiv',
      specialPrice: 'Preț Special',
      removePhoto: 'Prea multe imagini încărcate',
      yes: 'Da',
      no: 'Nu',
      success: 'Succes',
      required: 'necesar',
      back: 'Înapoi',
      next: 'Următorul',
      finish: 'Finalizează',
      duplicate: 'Duplică',
      select: 'Selectează',
      all: 'Toate',
      alls: 'Toti',
      reset: 'Resetează',
      export: 'Exportă',
      loadMore: 'Încarcă mai mult',
      viewDetails: 'Vezi Detalii',
      showing: '{length} rezultate afișate',
      enable: 'activezi',
      disable: 'dezactivezi',
      product: 'produsul',
      logout: 'Deconectare',
      from: 'de la',
      to: 'pana la',
      cancelCourier: 'Anulează curier',
      agree: 'De accord',
      agreePopupMessage: 'Pentru a permite browserului să redea sunete, trebuie să faceți clic pe butonul „De acord”. Aceasta va reda un sunet de test pentru a activa redarea sunetului in browser.',
      day: 'ziua',
      notCompleted: 'necompletat',
      saveChanges: 'Salvează schimbările',
      doYouWantToLogout: 'Vrei sa te deconectezi?',
      minutes: 'minute',
      hour: 'ora',
      hours: 'ore',
      deliveryMethod: 'Metode Livrare',
      customSort: 'Compania folosește sortarea custom',
      none: 'Niciunul',
      included: 'Inclus',
      error_not_open_kiosk: 'Kiosk Închis, Ne pare rău, dar kiosk-ul nostru este momentan închis, va rugăm reveniți în timpul programului de lucru',
      error_not_open_table: 'Trebuie să fii la masă pentru a comanda. Întoarce-te la masă și scanează din nou!',
      error_not_open_table_1: 'Linkul dumneavoastră nu este valid. Vă rugăm să mergeți la masă și să scanați din nou codul QR',
      error_not_open_table_2: 'Serviciul „Comandă la masă” nu este disponibil. Vă rugăm să vă adresați personalului',
      error_not_open_table_3: 'Serviciul „Comandă la masă” nu este disponibil. Vă rugăm să vă adresați personalului',
      error_not_open_table_4: 'Serviciul „Comandă la masă” nu este disponibil. Vă rugăm să vă adresați personalului',
      error_not_open_table_5: 'Serviciul „Comandă la masă” nu este disponibil. Vă rugăm să vă adresați personalului',
      error_not_open_table_6: 'Serviciul „Comandă la masă” nu este disponibil. Vă rugăm să vă adresați personalului',
      error_not_open_table_7: 'Linkul dumneavoastră nu este valid. Vă rugăm să mergeți la masă și să scanați din nou codul QR',
      error_not_open_table_8: 'Locația este în afara programului de lucru. Vă rugăm să așteptați până la ora deschiderii și să scanați codul QR de la masă',
      error: 'Eroare'
    },
    addOrder: {
      'back': 'Inapoi',
      'close': 'Închide',
      'productNavbar': 'Produs',
      'menuNavbar': 'Meniu',
      'payNavbar': 'Plată',
      'optionNavar': 'Opțiuni',
      'splashScreenOrderNow': 'Comandă acum',
      'chooseLanguage': 'Alege limba',
      'addToCart': 'Produsul a fost adăugat în coș',
      'order_id_freeze': 'Plata a fost inițiată. Vă rugăm să continuați plata sau să așteptați expirarea linkului de plată pentru a modifica comanda!',
      'euPlatesc_error': 'There was a problem with your request!',
      'euPlatesc_error1': 'Authentication failed',
      'euPlatesc_error2': 'Insufficient funds',
      'euPlatesc_error3': 'Transaction declined',
      'euPlatesc_error4': 'Card expired',
      'euPlatesc_error5': 'Invalid response',
      'relogin': 'Mai este cineva la masa? Daca nu sterge comanda anterioara!',
      'deleteOrder': 'Sterge',
      'couninueOrder': 'Continuă',
      'errorRelogin': 'Există o comandă deschisă! Te rog adresează-te chelnerului pentru a închide comanda!',
      'finishOrderMsg': 'Comanda ta a fost plasată cu succes! Rămâi la masă, mai departe ne ocupăm noi de tot!',
      'errorFinishOrderMsg': 'Plata eșuată! Va rugăm verificați datele introduse pentru plata! Incearcă din nou sau adresează-te ospătarului!',
      'payByCard': 'Plateste cu cardul',
      'payByCashMachine': 'Introduceți bancnotele în aparat',
      'payByCashMachineDone': 'Va rugam asteptati!',
      'howPay': 'Cum dorești să plătești?',
      'posGeneralError': 'Tranzacția a eșuat!',
      'selectMinMax': 'Poti selecta',
      'selectMin': ' minim',
      'selectMax': ' maxim',
      'cartBtn': 'Coșul meu',
      'emptyCartBtn': 'Golește coșul',
      'splashScreenWrapperStart': 'Atinge ecranul pentru a începe o comandă',
      'swipeUpTooltip': 'Derulează în jos pentru următoarea categorie',
      'resetQuestion': 'Doriți să începeți din nou?',
      'emptyCart': 'Doriți să stergeți toate produsele din coș?',
      'emptyCartProduct': 'Doriți să stergeți produsul din coș?',
      'yes': 'DA',
      'no': 'NU',
      'soldWithAdd': 'Adaugă',
      'soldWithNo': 'Nu doresc',
      'soldWithExtra': 'Total extra',
      'soldWithTitle': 'Recomandări',
      'couponExit': 'Atinge oriunde pentru a ieși',
      'couponTitle': 'Introdu codul cuponului',
      'enterCui': 'Introdu CUI-ul',
      'noProductsFound': 'Produsele căutate nu au fost găsite.',
      'couponPlaceholder': 'Scrie codul cuponului',
      'pagerTitle': 'Scaneaza codul QR sau scrie codul de pe pager',
      'pagerPlaceholder': 'Cod Pager',
      'pagerBtn': 'Adauga Pager',
      'couponBtn': 'Aplică cupon:',
      'commentBtn': 'Informații adiționale:',
      'couponButton': 'Aplică',
      'couponBtn2': 'Ai un cod promoțional?',
      'step1': 'Așteptați ca numărul comenzii să apară pe ecran',
      'step2': 'Ridicați comanda de la casă',
      'yourOrderNr': 'Număr comandă',
      'doneShortly': 'Comanda dvs. este în pregătire.',
      'thenks': 'Mulțumim!',
      'qrStep1': 'Pasul 1: Scanează codul QR cu camera de la smartphone.',
      'qrStep2': 'Pasul 2: Accesează link-ul, completează câmpurile (numărul de card, emailul) și bifează căsuțele. Atenție! Acceptarea termenilor și condițiilor este obligatorie, altfel nu se poate realiza plata.',
      'qrStep3': 'Pasul 3: Click pe butonul Plătește online',
      'qrStep4': 'Pasul 4: În câteva secunde vei primi confirmarea plății.',
      'qrCancel': 'Anulează',
      'qrText': 'Aveți la dispoziție ',
      'qrText2': 'secunde pentru a plăti comanda sau comanda va fi anulată',
      'backShopping': 'Înapoi la meniu',
      'qr': 'Online scanând codul QR',
      'cash_waiter': 'Cash la ospatar',
      'cash_bar': 'Cash la bar',
      'pos_waiter': 'POS la ospatar',
      'pos_bar': 'CARD/POS la bar',
      'card': 'Plată Online',
      'counter': 'La casă',
      'counter_cash': 'La casă cash',
      'counter_pos': 'La casă POS',
      'pack': 'Unde vei lua masa astăzi?',
      'takeAway': 'La pachet',
      'takeAway_first': 'La',
      'takeAway_second': 'pachet',
      'dineIn': 'Mananca in locatie',
      'dineIn_first': 'Mănâncă',
      'dineIn_second': 'în locație',
      'paymentOptions': 'Opțiuni de Plată',
      'empty': 'Coșul tău este gol',
      'backToMenu': 'Inapoi la meniu',
      'total': 'Total:',
      'search': 'Caută produse',
      'titleClient': 'Detalii client',
      'titleMethod': 'Metoda livrare',
      'titleLocation': 'Locatie',
      'titleAdress': 'Adresa livrare',
      'titleStatus': 'Status',
      'done': 'Gata',
      'datepicker': 'Alege data de livrare',
      'hourpicker': 'Alege ora de livrare',
      'how_many': 'Pentru cate persoame se face rezervarea',
      'tags': 'Comanda din',
      'titlePopupTip': 'Adaugă Valoarea',
      'btnPopup': 'Adaugă',
      'titlePopupCoupon': 'Adaugă cupon',
      'errorPopupCoupon': 'Cupon gresit',
      'errorProduct1': 'Produsele nu mai sunt disponibile și au fost șterse din coș',
      'errorProduct2': 'Unul sau mai multe produse nu mai sunt disponibile și au fost șterse din coș',
      'errorProduct3': 'Trebuie sa aveti produse in cos pentru a putea comanda!',
      'errorProduct4': 'Te rugam sa selectezi metoda si locatia',
      'errorProduct5': 'Te rog adaugă un client',
      'errorProduct6': 'Metoda de plata neselectata',
      'errorProduct7': 'Te rog adaugă o adresa',
      'add': 'Adaugă',
      'addFor': 'Adaugă pentru ',
      'edit': 'Editează',
      'next_to_option': 'Adaugă',
      'prev_to_option': 'Inapoi',
      'infosup': 'Adaugă informații suplimentare',
      'state': 'Județ',
      'city': 'Oraș',
      'adress': 'Bloc, scară, etaj, apartament',
      'number': 'Număr',
      'street': 'Strada',
      'adressname': 'Nume Adresa',
      'sexf': 'Feminin',
      'sexm': 'Masculin',
      'sex': 'Sex',
      'birthdate': 'Data nașterii',
      'contactperson': 'Persoana de contact',
      'newclient': 'Adaugă un client',
      'newadress': 'Adaugă sau alege adresa ',
      'save1': 'Alege si salveaza modificarile',
      'deliveryAdress': 'Adaugă o adresa noua',
      'deliveryAdressEdit': 'Editează adresa',
      'firstName': 'Prenume',
      'lastName': 'Nume',
      'contactPers': 'Persoana de contact',
      'clientSelected': 'Client selectat',
      'clearFields': 'Gloeste Campurile',
      'addAdress': '+ Adaugă adresa',
      'existingClient': 'Comanda trimisa din',
      'orderNow': 'Plătește',
      'pos': 'Cu cardul',
      'cash': 'Cash',
      'free': 'Gratis',
      'coment': 'Comentariu Comanda',
      'addTip': 'Adaugă bacșiș:',
      'addTipValue': 'Introdu valoare',
      'addTipButton': 'Adaugă',
      'removeTip': 'Sterge bacșiș',
      'removeTipButton': 'Sterge',
      'addCoupon': 'Adaugă cupon de reducere',
      'removeCoupon': 'Sterge cupon',
      'removeCouponButton': 'Sterge',
      'modif': 'Modifică',
      'delete': 'Sterge',
      'freeProd': 'Produs Gratuit',
      'info': 'Info',
      'orderDet': 'Detalii Comandă',
      'cartDet': 'Coșul meu',
      'fast': 'Cat mai rapid',
      'selectHour': 'Selecteaza ora',
      'selectPayment': 'Selecteaza metoda de plata',
      'pleaseSelectMethodAndLoc': 'Va rugam sa selectati metoda si locatia!',
      'locSelect': 'Selectati o locatie',
      'searchProduct': 'caută produse',
      'phone': 'Telefon',
      'email': 'E-mail',
      'inlocation': 'In Locatie',
      'cuiPlaceholder': 'Vrei CUI pe bon?',
      'emailFieldsTitle1': 'Ajută-ne să îmbunătățim experiența',
      'emailFieldsTitle2': 'Lasă-ne un email pentru a-ți trimite confirmarea comenzii!',
      'emailPlaceholder': 'Adresa e-mail',
      'phonePlaceholder': 'Numar Telefon',
      'phoneFieldsTitle1': 'Introdu numărul de telefon:',
      'phoneSearch': 'Introdu',
      'client': 'Client:',
      'newClient': 'Client Nou:',
      'phoneFidelityTitle': 'Încarcă puncte de fidelitate?',
      'phoneFieldsTitle2': 'Sau scanează codul QR din aplicație',
      'phoneError': 'Telefon invalid',
      'qrError': 'Cod Qr invalid, scaneaza din nou sau introdu numarul de telefon!',
      'emailError': 'Email invalid',
      'adressNotInRange': 'Esti prea departe, te rog schimba adresa!',
      'adressNotCorect': 'Adresa nu este corecta',
      'continueToPay': 'Continuă spre plată',
      'loyalityNoSms': 'Vrei puncte de loialitate?',
      'noLoyalitySms': 'Vrei să știi când este gata comanda?',
      'loyalitySms': 'Vrei să știi când este gata comanda și să primești puncte de loialitate?',
      'new_client_fidelity': 'După crearea unui cont în aplicație cu acest număr de telefon, punctele de loialitate vor fi atrbuite în mod automat contului respectiv.',
      'cardDesc1': 'Plata cu cardul în curs de procesare',
      'cardDesc2': 'Vă rugăm să așteptați câteva momente în timp ce tranzacția dvs. este procesată',
      'cardDesc3': 'Vă mulțumim pentru răbdare!'
    }
  },
}
export default messages